import { FC, ReactNode } from 'react';
import styles from './DeliveryOption.scss';
import { Radio } from 'dibs-elements/exports/Radio';

type Props = {
    name?: string;
    value: string | number;
    title: ReactNode;
    dutiesDescription?: ReactNode;
    description?: ReactNode;
    testName: string;
    isSelected?: boolean;
    disabled?: boolean;
    children?: ReactNode;
    onSelect: () => void;
};

const DeliveryOption: FC<Props> = ({
    name,
    value,
    title,
    testName,
    dutiesDescription = '',
    description = '',
    isSelected = false,
    disabled = false,
    onSelect,
}) => (
    <Radio
        wrapperClass={styles.wrapper}
        inputId={`quote-${value || name}`}
        name="shippingOption"
        value={value || name || ''}
        label={title}
        dataTn={testName}
        checked={isSelected}
        disabled={disabled}
        onChange={onSelect}
    >
        {dutiesDescription && (
            <div data-tn="delivery-option-duties-description" className={styles.description}>
                {dutiesDescription}
            </div>
        )}
        {isSelected && description && (
            <p data-tn="delivery-option-description" className={styles.description}>
                {description}
            </p>
        )}
    </Radio>
);

export default DeliveryOption;
